import { ReactNode } from "react";
import { Box, SxProps } from "@mui/material";

export function UISpacedBoxContent(props: {
    hideSpaceBefore?: boolean;
    spaceAfter?: boolean;
    padding?: string;
    children: ReactNode;
    sx?: SxProps;
}) {
    let children: ReactNode[] | undefined = undefined;
    if (Array.isArray(props.children)) {
        children = [];

        let key = 0;

        let lastChild = props.children[props.children.length - 1];
        let firstChild = props.children[0];

        for (let c of props.children) {
            if (c !== firstChild || !props.hideSpaceBefore) {
                children.push(
                    <Box
                        key={"item " + key}
                        height={"13px"}
                    ></Box>
                );
            }
            children.push(c);

            if (c === lastChild && props.spaceAfter) {
                children.push(
                    <Box
                        key={"item " + key}
                        height={"13px"}
                    ></Box>
                );
            }

            key = key + 1;
        }
    }

    if (!children) return <>{props.children}</>;

    return (
        <Box
            display={"flex"}
            flexDirection={"column"}
            overflow={"auto"}
            width={"100%"}
            padding={props.padding}
            sx={props.sx}
        >
            {children}
        </Box>
    );
}
